import { ClassificationClass } from "../../../interfaces/classification";
import {
  ClassifiedOffset,
  isSimpleOffset,
  Offset,
  ParameterByAttribute,
  PointSymbolType,
  SimpleOffset,
} from "../../../interfaces/style";
import { getParameterValue } from "./getFromClassified";

export const getOffsetParameterValue = (offset: Offset): SimpleOffset => [
  getParameterValue(offset[0]),
  getParameterValue(offset[1]),
];

const calculateOffsetValue = (baseSize: number, newSize: number, defaultOffset: number): number => {
  return (baseSize && defaultOffset * (newSize / baseSize)) || defaultOffset;
};

const createOffsetClassificationParameters = (
  value: ClassificationClass,
  baseSize: number,
  newSize: number,
  defaultOffsetValues: SimpleOffset,
): [ClassificationClass, ClassificationClass] => {
  return [
    {
      ...value,
      parameterValue: calculateOffsetValue(baseSize, newSize, defaultOffsetValues[0]),
    },
    {
      ...value,
      parameterValue: calculateOffsetValue(baseSize, newSize, defaultOffsetValues[1]),
    },
  ];
};

export const createOffsetClassification = (
  values: ClassificationClass[],
  baseValue: number,
  defaultOffset: SimpleOffset,
) => {
  const offsetX: ClassificationClass[] = [];
  const offsetY: ClassificationClass[] = [];

  values.forEach(item => {
    const [offsetValueX, offsetValueY] = createOffsetClassificationParameters(
      item,
      baseValue,
      // TODO ClassificationClass Generic
      item.parameterValue as number,
      defaultOffset,
    );

    offsetX.push(offsetValueX);
    offsetY.push(offsetValueY);
  });

  return { offsetX, offsetY };
};

const filterOffsetValues = (offset: ClassifiedOffset, newOffsetParams: ClassifiedOffset): ClassifiedOffset => {
  return newOffsetParams.map((parameter, index) => {
    return {
      ...offset[index],
      values: [
        ...offset[index].values.filter(
          offsetValue => !parameter.values.some(paramValue => paramValue.condition === offsetValue.condition),
        ),
        ...parameter.values,
      ],
    };
  }) as ClassifiedOffset;
};

export const addOffsetClassification = (
  symbol: PointSymbolType,
  classificationOffsetX: ParameterByAttribute<number>,
  classificationOffsetY: ParameterByAttribute<number>,
): PointSymbolType => {
  const offset: ClassifiedOffset = isSimpleOffset(symbol.offset)
    ? [classificationOffsetX, classificationOffsetY]
    : filterOffsetValues(symbol.offset, [classificationOffsetX, classificationOffsetY]);

  return {
    ...symbol,
    offset,
  };
};
